<template>
  <div class="home-redesign">
    <main>
      <HrHero :data="hero" />
      <HrQuickLinks :items="quickLinks" />
      <HrAboutStats :about="about" :stats="stats" />
      <HrDirections :items="directions" />
      <HrReviewsNews :review="review" :news="newsBlock" />
      <HrAdvantages :items="advantages" />
      <HrClosingBanners />
    </main>
  </div>
</template>

<script>
import '@/assets/scss/views/home-redesign.scss'

import HrHero from './components/HrHero.vue'
import HrQuickLinks from './components/HrQuickLinks.vue'
import HrAboutStats from './components/HrAboutStats.vue'
import HrDirections from './components/HrDirections.vue'
import HrReviewsNews from './components/HrReviewsNews.vue'
import HrAdvantages from './components/HrAdvantages.vue'
import HrClosingBanners from './components/HrClosingBanners.vue'

import {
  hero,
  quickLinks,
  about,
  stats,
  directions,
  review,
  newsBlock,
  advantages,
} from './homeRedesignData'

export default {
  name: 'IndexRedesign',
  components: {
    HrHero,
    HrQuickLinks,
    HrAboutStats,
    HrDirections,
    HrReviewsNews,
    HrAdvantages,
    HrClosingBanners,
  },
  metaInfo() {
    return {
      title: 'Главная (редизайн) | Перинатальный центр ДАР',
    }
  },
  data() {
    return {
      hero,
      quickLinks,
      about,
      stats,
      directions,
      review,
      newsBlock,
      advantages,
    }
  },
  mounted() {
    document.documentElement.style.scrollBehavior = 'smooth'
  },
}
</script>
